import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';

const useResize = (type) => {
  const [resize, setResize] = useState(0);

  // 防抖函數
  const resizeHandler = useRef(
    debounce(() => {
      if (type === 'rem') {
        let media;
        if (window.matchMedia('(min-width: 1028px)').matches) {
          media = 14;
        } else if (window.matchMedia('(min-width: 1024px)').matches) {
          media = 12;
        } else if (window.matchMedia('(min-width: 768px)').matches) {
          media = 10;
        } else {
          media = 8;
        }
        setResize(media);
      } else {
        setResize(getComputedStyle(document.getElementsByTagName('html')[0])['width']);
      }
    }, 300)
  ).current;

  // 清除副作用
  useEffect(() => {
    return () => {
      resizeHandler.cancel();
    };
  }, [resizeHandler]);

  useEffect(() => {
    // 监听
    window.addEventListener('resize', resizeHandler);

    // 销毁
    return () => window.removeEventListener('resize', resizeHandler);
  }, [resizeHandler]);

  return resize;
};

export default useResize;
